import React, { useEffect, useState } from "react";
import { useHistory , useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Form, Button, Card, Space } from "antd";
import FormFields from "./FormFields";
import { getPersonById, updatePerson } from "../../../redux/slices/persons/personsThunk";
import { toast } from "react-toastify";

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 12 },
};
const tailLayout = {
  wrapperCol: { offset: 12, span: 12, gutter: 10 },
};

const EditPharmaciesPage = () => {
  const [form] = Form.useForm();
  const { id } = useParams();
  const dispatch = useDispatch();
  const [oldDoc, setoldDoc] = useState({});

  useEffect(() => {
    dispatch(getPersonById(id)).then ((data) => {      
      setoldDoc(
        {
          government : data.payload?.government?.id,
          region : data.payload?.region?.id,
        }
      );
      form.setFieldsValue(
        {
          firstname: data.payload.firstname,
          lastname: data.payload.lastname,
          pharmacyName: data?.payload.pharmacien?.pharmacyName,
          email: data.payload.email,
          phoneNumber: data.payload.phoneNumber,
          address: data.payload.address,
          region: data.payload?.region?.name,
          government: data.payload?.government?.name,
          type: data.payload?.pharmacien?.pharmacyType,
        }
      );
    }
    );
    
  }, [dispatch, id, form]);

  const onFinish = (values) => {
    const formattedValues = {
      firstname: values.firstname,
      lastname: values.lastname,
      pharmacien: {
        pharmacyName: values.pharmacyName,
        pharmacyType: values.type,
      },
      email: values.email,
      phoneNumber: values.phoneNumber, 
      address: values.address,
      region: {
        id: typeof values.region === "string" ? oldDoc.region : values.region,
      },
      government: {
        id: typeof values.government === "string" ? oldDoc.government : values.government,
      },
    };
    const personId = id
    dispatch(updatePerson({ personId, personData: formattedValues })).then(() => {
      navigateTo("/pharmacies");
      toast.success("Pharmacie modifié avec succès");
    });
  };
  

  const onReset = () => {
    form.resetFields();
  };

  const history = useHistory();

  const navigateTo = (path) => {
    history.push(path);
  };


  return (
    <div>
      <Card
        bordered
        className="criclebox tablespace mb-24"
        title="Modifier une pharmacie"
      />
      <Card bordered={false}>
        <Form
          {...layout}
          form={form}
          name="control-hooks"
          onFinish={onFinish}
        >
          <FormFields intialGov ={oldDoc}/>
          <Form.Item {...tailLayout}>
            <Space size="small">
              <Button type="primary" htmlType="submit">
                Enregistrer
              </Button>
              <Button htmlType="button" onClick={onReset}>
                Reset
              </Button>
              <Button type="link" htmlType="button" onClick={() => navigateTo("/médecins")}>
                Annuler
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};


export default EditPharmaciesPage;
